var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsFullWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4689 17C0.92823 17 -0.0338869 15.3313 0.738042 13.9979L8.26915 0.989651C9.03948 -0.340919 10.9605 -0.340915 11.7309 0.989655L19.262 13.9979C20.0339 15.3313 19.0718 17 17.5311 17H2.4689ZM10 14C10.2833 14 10.5208 13.9042 10.7125 13.7125C10.9042 13.5208 11 13.2833 11 13C11 12.7167 10.9042 12.4792 10.7125 12.2875C10.5208 12.0958 10.2833 12 10 12C9.71667 12 9.47917 12.0958 9.2875 12.2875C9.09583 12.4792 9 12.7167 9 13C9 13.2833 9.09583 13.5208 9.2875 13.7125C9.47917 13.9042 9.71667 14 10 14ZM9 10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10V7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7V10Z",
    fill: "#FF8F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFullWarning);
export default __webpack_public_path__ + "static/media/icons_full_warning.0221af39.svg";
export { ForwardRef as ReactComponent };